/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Preview_Aria_LabelInputs */

const en_event_preview_aria_label = /** @type {(inputs: Event_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event preview`)
};

const fr_event_preview_aria_label = /** @type {(inputs: Event_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apercu de l'evenement`)
};

const de_event_preview_aria_label = /** @type {(inputs: Event_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsvorschau`)
};

const it_event_preview_aria_label = /** @type {(inputs: Event_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima dell'evento`)
};

const ru_event_preview_aria_label = /** @type {(inputs: Event_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр мероприятия`)
};

const es_event_preview_aria_label = /** @type {(inputs: Event_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa del evento`)
};

const zh_cn2_event_preview_aria_label = /** @type {(inputs: Event_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动预览`)
};

const ja_event_preview_aria_label = /** @type {(inputs: Event_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントプレビュー`)
};

const hi_event_preview_aria_label = /** @type {(inputs: Event_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट का पूर्वावलोकन`)
};

const pt_pt2_event_preview_aria_label = /** @type {(inputs: Event_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prévia do evento`)
};

/**
* | output |
* | --- |
* | "Event preview" |
*
* @param {Event_Preview_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_preview_aria_label = /** @type {((inputs?: Event_Preview_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Preview_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_preview_aria_label(inputs)
	if (locale === "de") return de_event_preview_aria_label(inputs)
	if (locale === "it") return it_event_preview_aria_label(inputs)
	if (locale === "ru") return ru_event_preview_aria_label(inputs)
	if (locale === "es") return es_event_preview_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_preview_aria_label(inputs)
	if (locale === "ja") return ja_event_preview_aria_label(inputs)
	if (locale === "hi") return hi_event_preview_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_preview_aria_label(inputs)
	return en_event_preview_aria_label(inputs)
});